<template>
    <div>
        <template v-if="preference != 'collection' || preference == 'collection' && basketTotal >= 6">
            <button class="btn btn-lg btn-green" @click="process">Proceed to Checkout</button>
            <guest-or-account-modal :checkout="true" :show="showChoiceModal" @close="showChoiceModal = false" @guest="checkout"></guest-or-account-modal>
        </template>
        <div v-if="preference == 'collection' && basketTotal < 6" class="alert alert-danger">
            You must spend a minimum of £5.00 + VAT on collection orders.
        </div>
    </div>
</template>

<script>
    import GuestOrAccountModal from '../Elements/Modals/GuestOrAccountModal.vue';

    export default {
        components: {
            GuestOrAccountModal
        },
        props: {
            basketTotal: {
                type: Number,
                default: 0
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            guest: {
                type: Boolean,
                default: true,
            },
            preference: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                showChoiceModal: false,
            }
        },
        mounted() {
            if (this.preference) {
                createCookie('delivery_preference', this.preference, 1440);
            }
        },
        methods: {
            checkout() {
                window.location = '/checkout?chosen=1';
            },
            process() {
                if (!this.guest) {
                   return this.checkout();
                }
                this.showChoiceModal = true;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/CheckoutBtn.vue